module.exports = __webpack_public_path__ + "media/images/icon-upload-985bbba4426ff13d079461e03673736d.svg";